export default __webpack_public_path__ + "static/media/PEN_Xmas2021_GiftGuide_Page_13.7c0cb2bc.jpg";